import React from 'react';
import classnames from 'classnames';
import s from './FeedLayout.scss';
const FeedLayout = ({ children , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['feed-wrapper']
    }, children));
FeedLayout.displayName = 'FeedLayout';
export default FeedLayout;
